'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _moment = require('moment/moment.js');

var _moment2 = _interopRequireDefault(_moment);

var _ProgressBarComponent = require('../components/common/ProgressBarComponent');

var _ProgressBarComponent2 = _interopRequireDefault(_ProgressBarComponent);

var _Path = require('./validators/common/Path');

var _Path2 = _interopRequireDefault(_Path);

var _Version = require('./validators/common/Version');

var _Version2 = _interopRequireDefault(_Version);

var _AssociationContainer = require('./containers/all-inclusive/lloyds/AssociationContainer');

var _AssociationContainer2 = _interopRequireDefault(_AssociationContainer);

var _AssociationNonMedicalContainer = require('./containers/association/lloyds/AssociationNonMedicalContainer');

var _AssociationNonMedicalContainer2 = _interopRequireDefault(_AssociationNonMedicalContainer);

var _AssociationOopContainer = require('./containers/oop/lloyds/AssociationOopContainer');

var _AssociationOopContainer2 = _interopRequireDefault(_AssociationOopContainer);

var _CanuckVoyageContainer = require('./containers/canuck/lloyds/CanuckVoyageContainer');

var _CanuckVoyageContainer2 = _interopRequireDefault(_CanuckVoyageContainer);

var _ComprehensivePlusContainer = require('./containers/student/lloyds/ComprehensivePlusContainer');

var _ComprehensivePlusContainer2 = _interopRequireDefault(_ComprehensivePlusContainer);

var _DiscoverCanadaContainer = require('./containers/visitors/products/DiscoverCanadaContainer');

var _DiscoverCanadaContainer2 = _interopRequireDefault(_DiscoverCanadaContainer);

var _EssentialContainer = require('./containers/student/lloyds/EssentialContainer');

var _EssentialContainer2 = _interopRequireDefault(_EssentialContainer);

var _EssentialWorldwideContainer = require('./containers/student/lloyds/EssentialWorldwideContainer');

var _EssentialWorldwideContainer2 = _interopRequireDefault(_EssentialWorldwideContainer);

var _ETRContainer = require('./containers/student/lloyds/ETRContainer');

var _ETRContainer2 = _interopRequireDefault(_ETRContainer);

var _ExploreCanadaContainer = require('./containers/student/lloyds/ExploreCanadaContainer');

var _ExploreCanadaContainer2 = _interopRequireDefault(_ExploreCanadaContainer);

var _IsContainer = require('./containers/international-students/lloyds/IsContainer');

var _IsContainer2 = _interopRequireDefault(_IsContainer);

var _MyCanadaPlanContainer = require('./containers/student/lloyds/MyCanadaPlanContainer');

var _MyCanadaPlanContainer2 = _interopRequireDefault(_MyCanadaPlanContainer);

var _MyCanadaPlanPlusContainer = require('./containers/student/lloyds/MyCanadaPlanPlusContainer');

var _MyCanadaPlanPlusContainer2 = _interopRequireDefault(_MyCanadaPlanPlusContainer);

var _OutboundContainer = require('./containers/student/lloyds/OutboundContainer');

var _OutboundContainer2 = _interopRequireDefault(_OutboundContainer);

var _StudentAccidentContainer = require('./containers/student_accident/lloyds/StudentAccidentContainer');

var _StudentAccidentContainer2 = _interopRequireDefault(_StudentAccidentContainer);

var _StudyCanadaContainer = require('./containers/student/lloyds/StudyCanadaContainer');

var _StudyCanadaContainer2 = _interopRequireDefault(_StudyCanadaContainer);

var _UsIsContainer = require('./containers/international-students/lloyds/UsIsContainer');

var _UsIsContainer2 = _interopRequireDefault(_UsIsContainer);

var _MsgAscnAllInclContainer = require('./containers/all-inclusive/lloyds/MsgAscnAllInclContainer');

var _MsgAscnAllInclContainer2 = _interopRequireDefault(_MsgAscnAllInclContainer);

var _MsgAscnNonMedicalContainer = require('./containers/association/lloyds/MsgAscnNonMedicalContainer');

var _MsgAscnNonMedicalContainer2 = _interopRequireDefault(_MsgAscnNonMedicalContainer);

var _MsgEmergencyMedicalContainer = require('./containers/canuck/lloyds/MsgEmergencyMedicalContainer');

var _MsgEmergencyMedicalContainer2 = _interopRequireDefault(_MsgEmergencyMedicalContainer);

var _MsgIsContainer = require('./containers/international-students/lloyds/MsgIsContainer');

var _MsgIsContainer2 = _interopRequireDefault(_MsgIsContainer);

var _MsgVisitorsToCanadaContainer = require('./containers/visitors/products/MsgVisitorsToCanadaContainer');

var _MsgVisitorsToCanadaContainer2 = _interopRequireDefault(_MsgVisitorsToCanadaContainer);

var _RimiCanuckVoyageContainer = require('./containers/canuck/lloyds/RimiCanuckVoyageContainer');

var _RimiCanuckVoyageContainer2 = _interopRequireDefault(_RimiCanuckVoyageContainer);

var _RimiSSIsContainer = require('./containers/rimi_is/lloyds/RimiSSIsContainer');

var _RimiSSIsContainer2 = _interopRequireDefault(_RimiSSIsContainer);

var _RimiVisitorsToCanadaContainer = require('./containers/visitors/products/RimiVisitorsToCanadaContainer');

var _RimiVisitorsToCanadaContainer2 = _interopRequireDefault(_RimiVisitorsToCanadaContainer);

var _VisitCanadaIsContainer = require('./containers/rimi_is/lloyds/VisitCanadaIsContainer');

var _VisitCanadaIsContainer2 = _interopRequireDefault(_VisitCanadaIsContainer);

var _VisitCanadaVisitorsContainer = require('./containers/visitors/products/VisitCanadaVisitorsContainer');

var _VisitCanadaVisitorsContainer2 = _interopRequireDefault(_VisitCanadaVisitorsContainer);

var _InsureCanadaIsContainer = require('./containers/rimi_is/lloyds/InsureCanadaIsContainer');

var _InsureCanadaIsContainer2 = _interopRequireDefault(_InsureCanadaIsContainer);

var _InsureCanadaVisitorContainer = require('./containers/visitors/products/InsureCanadaVisitorContainer');

var _InsureCanadaVisitorContainer2 = _interopRequireDefault(_InsureCanadaVisitorContainer);

var _Global2GoContainer = require('./containers/msh/global2go/Global2GoContainer');

var _Global2GoContainer2 = _interopRequireDefault(_Global2GoContainer);

var _Global2GoContainer3 = require('./containers/msh/questionnaire/Global2GoContainer');

var _Global2GoContainer4 = _interopRequireDefault(_Global2GoContainer3);

var _BclContainer = require('./containers/msh/global2go/BclContainer');

var _BclContainer2 = _interopRequireDefault(_BclContainer);

var _GenericContainer = require('./containers/msh/global2go/GenericContainer');

var _GenericContainer2 = _interopRequireDefault(_GenericContainer);

var _LivExpatContainer = require('./containers/msh/livexpat/LivExpatContainer');

var _LivExpatContainer2 = _interopRequireDefault(_LivExpatContainer);

var _Path3 = require('./validators/international-students/Path');

var _Path4 = _interopRequireDefault(_Path3);

var _RimiCanuckVoyageNonMedicalContainer = require('./containers/canuck/lloyds/RimiCanuckVoyageNonMedicalContainer');

var _RimiCanuckVoyageNonMedicalContainer2 = _interopRequireDefault(_RimiCanuckVoyageNonMedicalContainer);

var _PayFailedPayments = require('./components/PayFailedPayments');

var _PayFailedPayments2 = _interopRequireDefault(_PayFailedPayments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('normalize.css');
require('styles/App.scss');
require('styles/main.scss');
require('styles/contact-us.scss');
require('bootstrap-sass/assets/stylesheets/_bootstrap.scss');

var App = function App() {
  return _react2.default.createElement(
    _reactRouter.Router,
    { history: _reactRouter.browserHistory },
    _react2.default.createElement(_reactRouter.Redirect, { path: '/:source', to: '/en/:source' }),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: '/', onEnter: _Version2.default },
      _react2.default.createElement(
        _reactRouter.Route,
        { path: ':language', onEnter: _Path2.default },
        _react2.default.createElement(
          _reactRouter.Route,
          { path: 'msh' },
          _react2.default.createElement(_reactRouter.Route, { path: 'global2go', component: _Global2GoContainer2.default }),
          _react2.default.createElement(_reactRouter.Route, { path: 'global2goquestionnaire', component: _Global2GoContainer4.default }),
          _react2.default.createElement(_reactRouter.Route, { path: 'bcl', component: _BclContainer2.default }),
          _react2.default.createElement(_reactRouter.Route, { path: 'testing1', component: _GenericContainer2.default }),
          _react2.default.createElement(_reactRouter.Route, { path: 'livexpat', component: _LivExpatContainer2.default })
        ),
        _react2.default.createElement(_reactRouter.Route, { path: 'lloydsascnallincl', component: _AssociationContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'lloydsascnnonmed', component: _AssociationNonMedicalContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'lloydsascnoop', component: _AssociationOopContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'lloydscanuckvoyage', component: _CanuckVoyageContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'lloydscomprehensiveplus', component: _ComprehensivePlusContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'lloydsdiscovercanada', component: _DiscoverCanadaContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'lloydsessentialplanis', component: _EssentialContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'lloydsessentialworldwideplanis', component: _EssentialWorldwideContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'lloydsetrstudent', component: _ETRContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'lloydsexplorecanadais', component: _ExploreCanadaContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'lloydsis', component: _IsContainer2.default, onEnter: function onEnter(nextState, replace) {
            return (0, _Path4.default)(nextState, replace, 'lloydsis');
          } }),
        _react2.default.createElement(_reactRouter.Route, { path: 'lloydsmycanadais', component: _MyCanadaPlanContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'lloydsmycanadaplusis', component: _MyCanadaPlanPlusContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'lloydsoutboundstudent', component: _OutboundContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'studentaccidentplan', component: _StudentAccidentContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'lloydsstudycanadais', component: _StudyCanadaContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'lloydsusis', component: _UsIsContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'studentaccidentplan', component: _StudentAccidentContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'msgascnallincl', component: _MsgAscnAllInclContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'msgascnnonmed', component: _MsgAscnNonMedicalContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'msgemergencymedical', component: _MsgEmergencyMedicalContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'msgis', component: _MsgIsContainer2.default, onEnter: function onEnter(nextState, replace) {
            return (0, _Path4.default)(nextState, replace, 'lloydsis');
          } }),
        _react2.default.createElement(_reactRouter.Route, { path: 'msgvisitorstocanada', component: _MsgVisitorsToCanadaContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'rimicanuckvoyage', component: _RimiCanuckVoyageContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'rimissis', component: _RimiSSIsContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'rimivisitorstocanada', component: _RimiVisitorsToCanadaContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'rimicanuckvoyagenonmed', component: _RimiCanuckVoyageNonMedicalContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: '2visitcanadais', component: _VisitCanadaIsContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: '2visitcanadavisitors', component: _VisitCanadaVisitorsContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'insurecanadais', component: _InsureCanadaIsContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'insurecanadavisitor', component: _InsureCanadaVisitorContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'payfailedpayments', component: _PayFailedPayments2.default })
      )
    )
  );
};

exports.default = App;


//////////////////
// WEBPACK FOOTER
// ./src/v2/App.jsx
// module id = 1649
// module chunks = 0